import React from 'react';
import { MapPin, Mail, Phone } from 'lucide-react';

const Contact = () => {
    return (
        <div className="py-12 container mx-auto px-6">
            <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm overflow-hidden flex flex-col md:flex-row">
                {/* Contact Info Section (Left/Top) */}
                <div className="bg-emerald-800 text-white p-10 md:w-2/5">
                    <h2 className="font-display text-3xl mb-6">Get in Touch</h2>
                    <p className="text-emerald-100 mb-8">Have questions about the park? Need help with booking?</p>
                    
                    <div className="space-y-6">
                        <div className="flex items-start">
                            <MapPin className="mt-1 mr-4 text-yellow-400" />
                            <div>
                                <h4 className="font-bold">Location</h4>
                                <p className="text-sm text-emerald-100">123 Farm Road,<br/>Countryside, South Africa</p>
                            </div>
                        </div>
                        <div className="flex items-center">
                            <Mail className="mr-4 text-yellow-400" />
                            <p className="text-sm text-emerald-100">happyhounds007@gmail.com</p>
                        </div>
                        <div className="flex items-center">
                            <Phone className="mr-4 text-yellow-400" />
                            <p className="text-sm text-emerald-100">+27 72 384 3366</p>
                        </div>
                    </div>
                </div>

                {/* Contact Form Section (Right/Bottom) */}
                <div className="p-10 md:w-3/5">
                    <h3 className="font-display text-2xl text-gray-800 mb-6">Send a Message</h3>
                    <form className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                            <input type="text" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-emerald-500 focus:border-emerald-500" placeholder="Your Name" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                            <input type="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-emerald-500 focus:border-emerald-500" placeholder="you@example.com" />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                            <textarea rows="4" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-emerald-500 focus:border-emerald-500" placeholder="How can we help?"></textarea>
                        </div>
                        <button type="button" className="w-full bg-emerald-600 text-white font-bold py-3 rounded-lg hover:bg-emerald-700 transition">
                            Send Message
                        </button>
                    </form>
                </div>
            </div>
            
            {/* --- GOOGLE MAP SECTION --- */}
            <div className="max-w-4xl mx-auto mt-8 h-96 bg-gray-200 rounded-2xl overflow-hidden shadow-md border border-gray-300">
                <iframe 
                    title="Shep's Sniff Spot Location"
                    // I put a REAL Google Maps link here so you can see it works.
                    // You must replace this URL with your specific one later.
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d530.3500421178898!2d18.44544709402144!3d-33.72968993831023!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1dccf5e9c1cadf03%3A0x89e3381c30103cda!2sShep&#39;s%20Sniff%20Spot!5e1!3m2!1sen!2sus!4v1767612953052!5m2!1sen!2sus"
                    width="100%" 
                    height="100%" 
                    style={{ border: 0 }} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>
        </div>
    );
};

export default Contact;